import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { FlexBox, FlexBoxProps, Orientation } from '@lumapps/lumx/react';

import { useBlockPlaylistContext } from '../BlockPlaylistContext';
import { CLASSNAME as BLOCK_PLAYLIST_CLASSNAME } from '../constants';

import './Content.scss';

export const CLASSNAME = `${BLOCK_PLAYLIST_CLASSNAME}__content` as const;

type ContentProps = Pick<FlexBoxProps, 'as' | 'children' | 'gap'>;

/**
 * Main content of the component
 */
export const Content = ({ as, children, gap }: ContentProps) => {
    const { block } = useClassnames(CLASSNAME);

    const { canDisplay, isLoading, orientation } = useBlockPlaylistContext();

    if (!canDisplay('AUTHOR', 'DESCRIPTION', 'STATUS', 'TITLE', 'UPDATED_AT', 'VIDEO_COUNT')) {
        return null;
    }

    return (
        <FlexBox
            as={as}
            className={block()}
            fillSpace={isLoading && orientation === Orientation.horizontal}
            gap={gap}
            orientation={Orientation.vertical}
        >
            {children}
        </FlexBox>
    );
};
